import { headerNav } from '../data/HeaderData';

interface Props {
  onClose: () => void;
}

const MobileMenuDropdown: React.FC<Props> = ({ onClose }) => {
  return (
    <nav id='mobileNav' className='h-100 d-flex justify-content-center align-items-center'>
      <ul>
        {headerNav.map((link, index) => (
          <li key={index} className='d-flex justify-content-center'>
            
              < a href={link.url}
              className='text-primary py-2 my-2 display-5 fw-bold text-decoration-none'
              onClick={onClose}
            >
              {link.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default MobileMenuDropdown